// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"8fec529d","256":"d42a6239","339":"0f422536","475":"b7972072","876":"d9eb34d0"}[chunkId] + ".chunk.js";
};